/**
 * Created by m.igrachev on 3/14/2016.
 */
import React from "react";
import PropTypes from "prop-types";
import ArrayUtils from "@tinqin/tinqin-utils/src/array";
import ObjectUtils from "@tinqin/tinqin-utils/src/object";
import documentedProps from "./documentation/ActionMenuDocumentedProperties";

import("./ActionMenu.less");

export default class ActionMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selection: props.selection || []
        };
    }

    componentWillReceiveProps(newProps) {
        var stateToSet = {};
        if (
            newProps.selection &&
            !ArrayUtils.shallowEquals(newProps.selection, this.state.selection)
        ) {
            stateToSet.selection = newProps.selection;
        }

        if (!ObjectUtils.isEmpty(stateToSet)) {
            this.setState(stateToSet);
        }
    }

    buildItemClick(itemClick) {
        var currentSelection = Array.from(this.state.selection);
        var that = this;
        return (selectedItemId) => {
            if (currentSelection.includes(selectedItemId)) {
                currentSelection.splice(currentSelection.indexOf(selectedItemId), 1);
            } else if (this.props.multiSelectable) {
                currentSelection.push(selectedItemId);
            } else if (this.props.selectable) {
                currentSelection = [selectedItemId];
            }

            that.setState(
                {
                    selection: currentSelection
                },
                () => {
                    if (itemClick) {
                        itemClick(that.state);
                    } else if (that.props.onSelectItem) {
                        that.props.onSelectItem(that.state);
                    }
                }
            );
        };
    }

    buildItems(items) {
        var result = [];
        React.Children.forEach(items, (item, index) => {
            if (!React.isValidElement(item)) return;

            var allowedActionClasses = this.props.allowedActionClasses || ["Action"];
            const displayName = item.type.displayName || item.type.name;
            if (displayName.includes("Action") || allowedActionClasses.includes(displayName)) {
                var props = {
                    key: "action_" + index,
                    rightIcon: this.props.rightIcons,
                    onClick: this.buildItemClick(item.props.onClick)
                };
                if (this.state.selection.includes(item.props.id)) {
                    props.active = true;
                }
                result.push(React.cloneElement(item, props));
            }
        });

        return result;
    }

    render() {
        var items = this.buildItems(this.props.children);
        var extraClasses = this.props.extraClasses || "";
        var listClass = extraClasses + " tq-menu tq-selectable"; //Note it's always selectable we need cursor pointer!
        listClass += this.props.borders ? " tq-borders" : "";
        listClass += this.props.background ? " tq-menu-bg-" + this.props.background : "";

        return (
            <ul className={listClass} data-tq-id={this.props.dataTqId}>
                {items}
            </ul>
        );
    }
}

ActionMenu.displayName = "ActionMenu";

ActionMenu.propTypes = {
    extraClasses: PropTypes.string,
    borders: PropTypes.bool,
    rightIcons: PropTypes.bool,
    selectable: PropTypes.bool,
    multiSelectable: PropTypes.bool,
    selection: PropTypes.array,
    allowedActionClasses: PropTypes.array,
    background: PropTypes.string,
    onSelectItem: PropTypes.func,
    dataTqId: PropTypes.string
};

ActionMenu.documentedProps = documentedProps;
